import React from 'react';
import { Button } from '../ui/button';
import { Shield, Phone, TrendingUp, CheckCircle } from 'lucide-react';
import ShareButtons from '../ShareButtons';
import { openWhatsApp, trackShare, INSTAGRAM_URL } from './constants';

const STATS = [
  { value: '10K+', label: 'Usuarios activos' },
  { value: '98%', label: 'Satisfacción' },
];

export const HeroSection = () => (
  <section className="relative overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-purple-600 to-cyan-500">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-600/5 via-purple-600/5 to-cyan-500/5 opacity-20"></div>
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="w-72 h-72 bg-white/10 rounded-full absolute -top-36 -left-36 animate-pulse"></div>
        <div className="w-96 h-96 bg-cyan-300/10 rounded-full absolute -bottom-48 -right-48 animate-pulse delay-1000"></div>
      </div>
    </div>

    <div className="relative container mx-auto px-4 py-20 md:py-32">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="text-center lg:text-left">
          <div className="inline-flex items-center bg-white/10 backdrop-blur-md rounded-full px-4 py-2 mb-8">
            <TrendingUp className="h-4 w-4 text-yellow-300 mr-2" />
            <span className="text-white/90 text-sm font-medium">Tendencia #1 en seguros digitales</span>
          </div>

          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Seguros
            <span className="block bg-gradient-to-r from-yellow-300 to-orange-300 bg-clip-text text-transparent">Inteligentes</span>
            <span className="block text-white/90 text-2xl md:text-3xl lg:text-4xl font-normal">para el futuro</span>
          </h2>

          <p className="text-xl md:text-2xl text-white/80 mb-8 max-w-2xl">
            Únete a la revolución digital. Protección moderna, rápida y personalizada para la nueva generación.
          </p>

          <div className="grid grid-cols-2 gap-4 mb-8 max-w-md mx-auto lg:mx-0">
            {STATS.map((s) => (
              <div key={s.label} className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-white">{s.value}</div>
                <div className="text-white/80 text-sm">{s.label}</div>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Button
              size="lg"
              data-testid="hero-whatsapp-btn"
              className="bg-white text-blue-600 hover:bg-white/90 shadow-xl rounded-full px-8 py-6 text-lg font-semibold transform hover:scale-105 transition-all duration-300"
              onClick={openWhatsApp}
            >
              <Phone className="h-5 w-5 mr-2" />
              Contactar ahora
            </Button>
            <Button
              size="lg"
              variant="outline"
              data-testid="hero-instagram-btn"
              className="border-2 border-white/30 text-white hover:bg-white/10 backdrop-blur-md rounded-full px-8 py-6 text-lg font-semibold"
              onClick={() => window.open(INSTAGRAM_URL, '_blank')}
            >
              Seguir en Instagram
            </Button>
          </div>
          <div className="mt-6 flex justify-center lg:justify-start">
            <ShareButtons variant="dark" onShare={trackShare} />
          </div>
        </div>

        <div className="relative">
          <div className="relative z-10">
            <img
              src="https://images.unsplash.com/photo-1548092372-0d1bd40894a3"
              alt="Tecnología de seguros moderna"
              className="rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-600/20 to-transparent rounded-2xl"></div>
          </div>
          <div className="absolute -top-6 -right-6 bg-white/10 backdrop-blur-md rounded-xl p-4 animate-float">
            <Shield className="h-6 w-6 text-yellow-300" />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white/10 backdrop-blur-md rounded-xl p-4 animate-float delay-1000">
            <CheckCircle className="h-6 w-6 text-green-300" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
